<template>
  <v-list class="py-0 info-list">
    <template v-for="(group, gIndex) in properties">
      <v-subheader
        :key="gIndex"
        class="pr-0"
      >
        <a @click="expandGroup(gIndex, group.lastGroup)">{{ group.title }}</a>
        <v-spacer />
        <slot
          v-if="group.event"
          :name="group.event"
          style="padding-right:7px"
        />
        <transition
          name="list"
          mode="out-in"
          :duration="{ enter: 500, leave: 500 }"
        >
          <v-btn
            v-if="group.lastGroup && showButton"
            class="expand-button elevation-0 pa-0 ma-0"
            color="grey lighten-2"
            small
            @click="expandGroup(gIndex, group.lastGroup)"
          >
            {{ expandedGroups.indexOf(gIndex) === -1 ? "+" : "-"
            }}{{ group.items.filter(i => !i.showAlways).length }}
          </v-btn>
        </transition>
      </v-subheader>
      <transition-group
        :key="group.items.title"
        :duration="{ enter: 800, leave: 500 }"
        name="list"
      >
        <v-list-tile
          v-for="(property, index) in group.items"
          v-show="property.showAlways || expandedGroups.indexOf(gIndex) !== -1"
          :key="index.toString() + gIndex.toString()"
          class="compact px-0"
          :style="{
            background: `${!property.showAlways ? '#F5F5F5' : 'none'}`
          }"
        >
          <v-layout
            v-if="property.type != 'array'"
            row
          >
            <v-flex xs6>
              <span
                class="blue--text text--darken-4 list-item"
              >{{ property.title }}:</span>
            </v-flex>
            <v-flex
              xs6
              class="list-item"
            >
              <span v-if="property.type === 'digit'">{{
                property.value | separateDigits
              }}</span>
              <span v-else-if="property.type === 'date'">{{
                property.value | date
              }}</span>
              <span v-else-if="property.type === 'dateRange'">{{
                property.value | dateRange
              }}</span>
              <span v-else-if="property.type === 'string-list'">{{
                property.value | stringList(true)
              }}</span>
              <span v-else>{{ property.value }}</span>
            </v-flex>
          </v-layout>
          <v-layout
            v-else
            column
          >
            <v-list
              v-for="(items, index) in property.value"
              :key="index"
              :class="index > 0 ? 'pb-1 pt-0' : 'py-1'"
            >
              <v-list-tile
                v-for="(item, index) in items"
                :key="index"
                class="compact px-0"
                :style="{
                  background: `${!property.showAlways ? '#F5F5F5' : 'none'}`
                }"
              >
                <v-layout row>
                  <v-flex xs6>
                    <span
                      class="blue--text text--darken-4 list-item"
                    >{{ item.title }}:</span>
                  </v-flex>
                  <v-flex
                    xs6
                    class="list-item"
                  >
                    <span>{{ item.value }}</span>
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </v-list>
          </v-layout>
          <v-list-tile-action class="py-0">
            <v-spacer />
            <slot
              v-if="property.event && property.value && property.value.length > 0"
              :name="property.event"
            />
            <transition
              v-else
              name="list"
              mode="out-in"
              :duration="{ enter: 500, leave: 500 }"
            >
              <v-btn
                v-if="
                  group.items.filter(i => !i.showAlways).length > 0 &&
                    (expandedGroups.indexOf(gIndex) === -1
                      ? index ===
                        group.items.filter(i => i.showAlways).length - 1
                      : index === group.items.length - 1)
                "
                class="expand-button elevation-0"
                color="grey lighten-2"
                small
                @click="expandGroup(gIndex, group.lastGroup)"
              >
                {{ expandedGroups.indexOf(gIndex) === -1 ? "+" : "-"
                }}{{ getLengthOfUnvisibleItems(group.items) }}
              </v-btn>
            </transition>
          </v-list-tile-action>
        </v-list-tile>
      </transition-group>
    </template>
  </v-list>
</template>

<script>
export default {
  props: ["items"],
  data() {
    return {
      expandedGroups: [],
      showButton: true,
    };
  },
  computed: {
    properties() {
      return this.items;
    },
  },
  methods: {
    expandGroup(index, lastGroup) {
      if (lastGroup) {
        this.showButton = !this.showButton;
      }
      const expandedIndex = this.expandedGroups.indexOf(index);
      if (expandedIndex === -1) {
        this.expandedGroups.push(index);
      } else {
        this.expandedGroups.splice(expandedIndex, 1);
      }
    },
    getLengthOfUnvisibleItems(items) {
      const notShowAlwaysItems = items.filter(i => !i.showAlways);
      let itemsLength = 0;
      notShowAlwaysItems.forEach(i => {
        if (i.type === "array" && i.value.length) {
          i.value.forEach(v => (itemsLength += v.length));
        }
      });
      return itemsLength
        ? notShowAlwaysItems.length - 1 + itemsLength
        : notShowAlwaysItems.length;
    },
  },
};
</script>

<style>
.compact-select.v-text-field.v-text-field--solo > .v-input__control {
  min-height: auto;
}

.compact-select.v-text-field input {
  padding-top: 0px;
  padding-bottom: 0px;
}

.compact-select .v-select__selection--comma {
  margin-top: 0px;
  margin-bottom: 0px;
}

.info-list .v-subheader {
  height: auto;
}

.info-list a {
  color: inherit;
}
.v-btn.expand-button {
  width: 35px;
  height: 21px;
  min-width: 35px;
  min-height: 21px;
  border-radius: 10px;
}
.list-item {
  transition: all 1s;
  word-wrap: break-word;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.v-menu .v-menu__activator .title {
  padding-right: 7px;
}
</style>
